// extracted by mini-css-extract-plugin
export default {"withIcon":"TimeInput_withIcon__0Z12V","clockIcon":"TimeInput_clockIcon__wXazP"};